import PropTypes from 'prop-types';
import React from 'react';
import styles from './Badge.module.css';

function Badge({ color = 'neutral', label, size = 'small' }) {
  return (
    <div className={`${styles.badge} ${styles[color]} ${styles[size]} `}>
      <span className={styles.label}>{label}</span>
    </div>
  );
}

Badge.propTypes = {
  color: PropTypes.oneOf([
    'neutral',
    'primary',
    'purple',
    'green',
    'yellow',
    'red',
  ]),
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default Badge;
